import React from 'react';
import { Link } from 'react-router-dom';
import { FramePlaceholderBoundary } from './FramePlaceholderBoundary';
import { OrderLineItem } from './OrderLineItem';
import { QuantityStepper } from '../ui/QuantityStepper';
import { usePrototype } from '../../contexts/PrototypeContext';
import { siteConfig } from '../../data/siteConfig';
import { formatPrice } from '../../utils/currency';
import { buttonClasses } from '../../utils/buttonStyles';

/**
 * VISUAL PLACEHOLDER — native Website Forge CART frame output.
 *
 * Not a production cart. At integration, render the EXISTING native cart frame and keep
 * its emitted HTML/actions, line-item markup, SKU/quantity/options, update/remove
 * actions, hidden inputs and totals. Free shipping reflects the approved design brief;
 * configure the native shipping rules at integration. Tax belongs to the native checkout.
 * Quantity is simulated in prototype state only.
 */
export function WfCartFramePreview() {
  const {
    quantity,
    setQuantity
  } = usePrototype();
  const subtotal = siteConfig.product.samplePrice * quantity;
  if (quantity === 0) {
    return <FramePlaceholderBoundary frame="WfCartFramePreview" data-id="element-37" data-mp="3867v3t0nwxy7">
        <div className="border-y border-line py-16 text-center" data-id="element-38" data-mp="3m70no87eliyo">
          <p className="font-display text-3xl text-ink" data-id="element-39" data-mp="3m694jwuztdpa">Your Skincare Cart is empty.</p>
          <p className="mt-3 text-[16px] text-ink-muted" data-id="element-40" data-mp="3h8h42ega8j9h">The AuraGlow Luxe mask is ready when you are.</p>
          <Link to="/#the-mask" className={`${buttonClasses('primary')} mt-8`} data-id="element-41" data-mp="2timr7wvyqup8">
            Shop the mask
          </Link>
        </div>
      </FramePlaceholderBoundary>;
  }
  return <FramePlaceholderBoundary frame="WfCartFramePreview" data-id="element-42" data-mp="339r5svhq8djj">
      <div className="grid gap-12 lg:grid-cols-[1.6fr_1fr] lg:gap-16" data-id="element-43" data-mp="2ygy127m9d57g">
        <div className="border-y border-line py-8" data-id="element-44" data-mp="2yfmy2a0n01he">
          <OrderLineItem quantity={quantity} data-id="element-45" data-mp="2aqtzs6wjlhjm">
            <div className="flex flex-wrap items-center gap-x-6 gap-y-3" data-id="element-46" data-mp="2apiwe870ebt1">
              <QuantityStepper value={quantity} onChange={setQuantity} min={1} label="Quantity" data-id="element-47" data-mp="25sinlpiryuy8" />
              <button type="button" onClick={() => setQuantity(0)} className="inline-flex min-h-[44px] items-center text-[14px] text-ink-muted underline underline-offset-4 hover:text-ink" data-id="element-48" data-mp="9pdxqebbcmqb">
                Remove
              </button>
            </div>
          </OrderLineItem>
        </div>

        <aside aria-label="Skincare Cart summary" className="border-t border-ink pt-6" data-id="element-49" data-mp="3mwpetg3r9wrt">
          <dl className="space-y-3 text-[15px]" data-id="element-50" data-mp="3ruzarsxb11eh">
            <div className="flex justify-between" data-id="element-51" data-mp="3rvsk91nne50b">
              <dt className="text-ink-muted" data-id="element-52" data-mp="3vx45yw3ei638">Subtotal</dt>
              <dd className="font-medium tabular-nums text-ink" data-id="element-53" data-mp="3vvjbf6h36n5d">{formatPrice(subtotal)}</dd>
            </div>
            <div className="flex justify-between gap-4" data-id="element-54" data-mp="4ogk8f190gv5">
              <dt className="text-ink-muted" data-id="element-55" data-mp="1b5ljp1k9fw1h">Shipping</dt>
              <dd className="text-right text-ink" data-id="element-56" data-mp="1g5pymn5isipl">Free</dd>
            </div>
            <div className="flex justify-between gap-4" data-id="element-57" data-mp="1g7szy3c4hy9m">
              <dt className="text-ink-muted" data-id="element-58" data-mp="1q8lidmh1e8tf">Tax</dt>
              <dd className="text-right text-ink-muted" data-id="element-59" data-mp="1qbhgpbwsqzie">Calculated at checkout</dd>
            </div>
          </dl>
          <Link to="/checkout" className={`${buttonClasses('primary', true)} mt-8`} data-id="element-60" data-mp="1gjlj01ymhbep">
            Checkout
          </Link>
          <Link to="/#the-mask" className="mt-3 flex min-h-[44px] items-center justify-center text-[14px] text-ink underline underline-offset-4" data-id="element-61" data-mp="1cj1katyehzqg">
            Continue shopping
          </Link>
        </aside>
      </div>
    </FramePlaceholderBoundary>;
}